import { render, staticRenderFns } from "./MainComp.vue?vue&type=template&id=6f34a8be&"
import script from "./MainComp.vue?vue&type=script&lang=js&"
export * from "./MainComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports